import { theme } from 'antd';
import { ThemeConfig } from 'antd/lib';

export const defaultTheme: ThemeConfig = {
	components: {
		Breadcrumb: {
			colorBgTextHover: 'transparent'
		},
		Card: {
			borderRadius: 4
		},
		Tag: {
			defaultBg: '#fafafa'
		}
	},
	token: {
		borderRadius: 4,
		// Arovy Charcoal
		colorTextBase: '#292929',
		// eslint-disable-next-line max-len
		fontFamily: '\'Public Sans\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Helvetica Neue\', Arial, \'Noto Sans\', sans-serif, \'Apple Color Emoji\', \'Segoe UI Emoji\', \'Segoe UI Symbol\', \'Noto Color Emoji\''
	}
};

export const darkTheme: ThemeConfig = {
	algorithm: theme.darkAlgorithm,
	...defaultTheme,
	components: {
		...defaultTheme.components,
		Input: {
			colorBorder: 'rgba(250, 250, 250, 0.45)',
			colorText: 'rgba(255, 255, 255, 0.65)'
		}
	},
	token: {
		colorBorder: 'rgba(250, 250, 250, 0.45)',
		colorTextPlaceholder: 'rgba(255, 255, 255, 0.45)'
	}
};
